import"core-js/modules/es.array.slice.js";import{findCountryByPrefix}from"../findCountryByPrefix";/**
 * Given a sting in a valid format ex:'+447573135343' it returns an object of shape
 * {prefix=+44 ,suffix=7573135343}
 *
 * @param {string} number - a string that defines a phone number.
 * @returns {{prefix: (string|*), suffix: string, format: string}}
 */export var explodeNumberModel=function(a){var b="",c="",d="",e=findCountryByPrefix(a);return e?(b=e.phone,c=a.slice(e.phone.length),d=e.phoneFormat||""):(b="",c=a.slice(1),d=""),{prefix:b,suffix:c,format:d}};